// extracted by mini-css-extract-plugin
export var cardLayout = "ResourceGrid-module--card--layout--83bf1";
export var listLayout = "ResourceGrid-module--list--layout--e41ee";
export var resourceGrid = "ResourceGrid-module--resource-grid--f1414";